import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./Header.css";
import { CircularProgress } from "@mui/material";

export default function Header({ slides }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [isImagesLoaded, setIsImagesLoaded] = useState(false);

  // const slides = [
  //   {
  //     image:
  //       "https://cdn.pixabay.com/photo/2018/02/26/22/17/machine-3184176_1280.jpg",
  //     title: "Máquinas de Alta Calidad",
  //     description: "Herramientas que llevan tus proyectos al siguiente nivel.",
  //   },
  //   {
  //     image: "https://unirental.com.ar/img/Unirental_Home_2doSCROLL.jpg",
  //     title: "Alquiler de Equipos Industriales",
  //     description: "Rendimiento y eficiencia en cada trabajo.",
  //   },
  //   {
  //     image:
  //       "https://webpicking.com/wp-content/uploads/2022/05/autoelevadores-AGP.jpeg",
  //     title: "Elevación sin Límites",
  //     description: "Soluciones confiables para proyectos exigentes.",
  //   },
  // ];

  useEffect(() => {
    // Pre-cargar las imágenes
    slides.map((slide) => {
      const img = new Image();
      img.src = slide.image;
      img.onload = () => {
        setIsImagesLoaded(true); // Cambia el estado cuando todas las imágenes estén cargadas
      };
      return img;
    });
    // Cambiar el slide cada 5 segundos
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === slides.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [slides]);

  if (slides.length === 0) {
    return (
      <div
        style={{
          height: 300,
          textAlign: "center",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#c3c3c3",
        }}
      >
        <div style={{ paddingTop: "12rem", width: "50%" }}>
          <CircularProgress />
        </div>
      </div>
    );
  }

  return (
    <header
      className="header"
      style={{
        backgroundImage: `url(${slides[currentIndex].image})`,
        objectFit: "contain",
      }}
    >
      <div className="header-content">
        {isImagesLoaded && (
          <>
            <motion.div
              key={slides[currentIndex].title}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <h1>{slides[currentIndex].title}</h1>
            </motion.div>
            <motion.p
              key={slides[currentIndex].description}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              {slides[currentIndex].description}
            </motion.p>
          </>
        )}

        <button
          className="cta-button"
          onClick={() => {
            const contactSection = document.getElementById("cotizacion");
            if (contactSection) {
              contactSection.scrollIntoView({ behavior: "smooth" });
            }
          }}
        >
          Solicita tu Cotización
        </button>
      </div>
    </header>
  );
}
